






import { Component, Prop, Vue } from 'vue-property-decorator'
import { ReadyPlayer } from '@/class/room'
import SimpleModal from '@/components/Utils/modal/SimpleModal.vue'

@Component({
  components: {
    SimpleModal
  }
})
export default class ReadyModal extends Vue {
  @Prop() self?: ReadyPlayer;
  showsModal = true

  get readyMessage () {
    if (this.self && this.self.selectablePriorityRole.length) {
      return '好きな役職をお選び下さい。選ばなかった場合は通常通り抽選が行われます。'
    } else {
      return '役職割り振り中です。時間までお待ちください。'
    }
  }
}
